import { Component, ComponentFactory, NgModule, Input, Injectable } from '@angular/core';
// import { JitCompiler }  from '@angular/compiler';
let _ = require('lodash');

import { ComputeVCDModule } from '../compute-vcd/compute-vcd.module';
import { ComputeVCModule }  from '../compute-vc/compute-vc.module';

import {
    Compiler,
    CompilerFactory,
    COMPILER_OPTIONS
  } from '@angular/core'


export interface DynamicData {
    entity: any;
}

@Injectable()
export class DynamicTypeBuilder {
    private _cacheOfFactories: {[templateKey: string]: ComponentFactory<DynamicData>} = {};

    constructor(protected compiler: Compiler) {
    }

    public createComponentFactory(template: string): Promise<ComponentFactory<DynamicData>> {

        let factory = this._cacheOfFactories[template];

        if (factory) {
            return new Promise((resolve) => {
                resolve(factory);
            });
        }

        let type = this.createNewComponent(template);
        let module = this.createComponentModule(type);

        return new Promise((resolve) => {
            this.compiler
                .compileModuleAndAllComponentsAsync(module)
                .then((moduleWithFactories) => {
                    factory = _.find(moduleWithFactories.componentFactories, {componentType: type});
                    this._cacheOfFactories[template] = factory;
                    resolve(factory);
                });
        });
    }

    protected createNewComponent(tmpl: string) {
        @Component({
            selector: 'dynamic-component',
            template: tmpl
        })
        class CustomDynamicComponent implements DynamicData {
            @Input() entity: any;
        }
        return CustomDynamicComponent;
    }

    protected createComponentModule(componentType: any) {
        @NgModule({
            imports: [
                // Add Modules having service components here
                ComputeVCDModule, ComputeVCModule
            ],
            declarations: [
                componentType
            ]
        })
        class RuntimeComponentModule {
        }
        return RuntimeComponentModule;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/dynamic-compute/type.builder.ts